// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TreeItem_Wrapper__0D-Hy {
  box-sizing: border-box;
  margin-bottom: -1px;
  padding-left: var(--spacing);

  list-style: none;

  &.TreeItem_clone__r2rop {
    display: inline-block;

    padding: 0;
    padding-top: 5px;
    padding-left: 10px;

    pointer-events: none;

    .TreeItem_TreeItem__InMPE {
      padding-right: 24px;

      border-radius: 4px;
      box-shadow: 0 15px 15px 0 rgb(34 33 81 / 10%);
    }
  }
}

.TreeItem_TreeItem__InMPE {
  position: relative;

  display: flex;
  align-items: start;

  box-sizing: border-box;
  padding-left: 18px;
}

.TreeItem_Count__sWNJo {
  position: absolute;
  z-index: 1;
  top: -10px;
  right: -10px;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 24px;
  height: 24px;

  color: #fff;
  border-radius: 50%;
  background-color: #2389ff;

  font-size: 0.8rem;
  font-weight: 600;
}

.TreeItem_title__1xT\\+- {
  font-size: 14px;
  line-height: 18px;
}

.TreeItem_addButton__uQDEs {
  display: flex;
  align-items: center;

  transition: opacity 250ms ease;

  opacity: 0;
  color: inherit;

  font-size: 14px;
}

.TreeItem_content__z7oHI {
  width: 100%;

  &:hover .TreeItem_title__1xT\\+- {
    text-decoration: none;

    color: var(--blue-60);
  }

  &:hover .TreeItem_addButton__uQDEs {
    opacity: 1;
  }

  &:hover path {
    fill: var(--blue-60);
  }
}

.TreeItem_disableInteraction__E1uFR {
  pointer-events: none;
}

.TreeItem_disableSelection__Fzlrg,
.TreeItem_clone__r2rop {
  .TreeItem_Text__Ge5Oy,
  .TreeItem_Count__sWNJo {
    -webkit-user-select: none;
            user-select: none;
    user-select: none;
  }
}

.TreeItem_collapseButton__AwjOh {
  margin-top: 8px;
  margin-right: 5px;

  cursor: pointer;

  svg {
    transition: transform 250ms ease;
  }

  &.TreeItem_collapsed__EdAca svg {
    transform: rotate(90deg);

    & path {
      fill: var(--blue-60);
    }
  }
}

.TreeItem_collapseLine__s5BLp::after {
  position: absolute;
  top: 10px;
  left: 9px;

  width: 6px;
  height: 1px;

  content: "";

  background-color: var(--gray-20);
}

.TreeItem_order__BiHQU {
  position: absolute;
  top: 0;
  left: 8px;

  display: flex;
  align-items: center;

  height: calc(100% + 10px);
  padding-right: 0.5rem;

  transition: background-color 250ms ease;

  border-left: 1px solid var(--gray-20);
}

.TreeItem_nextElement__P0j8v {
  height: 11px;
}

.TreeItem_childOrder__tAXnN {
  top: 17px;
  left: 20px;

  height: calc(100% - 7px);
}

.TreeItem_active__3oLsz {
  & .TreeItem_title__1xT\\+- {
    text-decoration: none;

    color: var(--blue-60);
  }
}

.TreeItem_linkActive__OQzR4 {
  color: var(--blue-60);
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/zones/Sidebar/TreePages/TreeItem.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;;EAE5B,gBAAgB;;EAEhB;IACE,qBAAqB;;IAErB,UAAU;IACV,gBAAgB;IAChB,kBAAkB;;IAElB,oBAAoB;;IAEpB;MACE,mBAAmB;;MAEnB,kBAAkB;MAClB,6CAA6C;IAC/C;EACF;AACF;;AAEA;EACE,kBAAkB;;EAElB,aAAa;EACb,kBAAkB;;EAElB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,WAAW;EACX,YAAY;;EAEZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;;EAEzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;;EAEnB,8BAA8B;;EAE9B,UAAU;EACV,cAAc;;EAEd,eAAe;AACjB;;AAEA;EACE,WAAW;;EAEX;IACE,qBAAqB;;IAErB,qBAAqB;EACvB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE;;IAEE,yBAAiB;YAAjB,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;;EAEjB,eAAe;;EAEf;IACE,gCAAgC;EAClC;;EAEA;IACE,wBAAwB;;IAExB;MACE,oBAAoB;IACtB;EACF;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;;EAET,UAAU;EACV,WAAW;;EAEX,WAAW;;EAEX,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;;EAET,aAAa;EACb,mBAAmB;;EAEnB,yBAAyB;EACzB,qBAAqB;;EAErB,uCAAuC;;EAEvC,qCAAqC;AACvC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,UAAU;;EAEV,wBAAwB;AAC1B;;AAEA;EACE;IACE,qBAAqB;;IAErB,qBAAqB;EACvB;AACF;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB","sourcesContent":[".Wrapper {\n  box-sizing: border-box;\n  margin-bottom: -1px;\n  padding-left: var(--spacing);\n\n  list-style: none;\n\n  &.clone {\n    display: inline-block;\n\n    padding: 0;\n    padding-top: 5px;\n    padding-left: 10px;\n\n    pointer-events: none;\n\n    .TreeItem {\n      padding-right: 24px;\n\n      border-radius: 4px;\n      box-shadow: 0 15px 15px 0 rgb(34 33 81 / 10%);\n    }\n  }\n}\n\n.TreeItem {\n  position: relative;\n\n  display: flex;\n  align-items: start;\n\n  box-sizing: border-box;\n  padding-left: 18px;\n}\n\n.Count {\n  position: absolute;\n  z-index: 1;\n  top: -10px;\n  right: -10px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  width: 24px;\n  height: 24px;\n\n  color: #fff;\n  border-radius: 50%;\n  background-color: #2389ff;\n\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.title {\n  font-size: 14px;\n  line-height: 18px;\n}\n\n.addButton {\n  display: flex;\n  align-items: center;\n\n  transition: opacity 250ms ease;\n\n  opacity: 0;\n  color: inherit;\n\n  font-size: 14px;\n}\n\n.content {\n  width: 100%;\n\n  &:hover .title {\n    text-decoration: none;\n\n    color: var(--blue-60);\n  }\n\n  &:hover .addButton {\n    opacity: 1;\n  }\n\n  &:hover path {\n    fill: var(--blue-60);\n  }\n}\n\n.disableInteraction {\n  pointer-events: none;\n}\n\n.disableSelection,\n.clone {\n  .Text,\n  .Count {\n    user-select: none;\n    user-select: none;\n  }\n}\n\n.collapseButton {\n  margin-top: 8px;\n  margin-right: 5px;\n\n  cursor: pointer;\n\n  svg {\n    transition: transform 250ms ease;\n  }\n\n  &.collapsed svg {\n    transform: rotate(90deg);\n\n    & path {\n      fill: var(--blue-60);\n    }\n  }\n}\n\n.collapseLine::after {\n  position: absolute;\n  top: 10px;\n  left: 9px;\n\n  width: 6px;\n  height: 1px;\n\n  content: \"\";\n\n  background-color: var(--gray-20);\n}\n\n.order {\n  position: absolute;\n  top: 0;\n  left: 8px;\n\n  display: flex;\n  align-items: center;\n\n  height: calc(100% + 10px);\n  padding-right: 0.5rem;\n\n  transition: background-color 250ms ease;\n\n  border-left: 1px solid var(--gray-20);\n}\n\n.nextElement {\n  height: 11px;\n}\n\n.childOrder {\n  top: 17px;\n  left: 20px;\n\n  height: calc(100% - 7px);\n}\n\n.active {\n  & .title {\n    text-decoration: none;\n\n    color: var(--blue-60);\n  }\n}\n\n.linkActive {\n  color: var(--blue-60);\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Wrapper": `TreeItem_Wrapper__0D-Hy`,
	"clone": `TreeItem_clone__r2rop`,
	"TreeItem": `TreeItem_TreeItem__InMPE`,
	"Count": `TreeItem_Count__sWNJo`,
	"title": `TreeItem_title__1xT+-`,
	"addButton": `TreeItem_addButton__uQDEs`,
	"content": `TreeItem_content__z7oHI`,
	"disableInteraction": `TreeItem_disableInteraction__E1uFR`,
	"disableSelection": `TreeItem_disableSelection__Fzlrg`,
	"Text": `TreeItem_Text__Ge5Oy`,
	"collapseButton": `TreeItem_collapseButton__AwjOh`,
	"collapsed": `TreeItem_collapsed__EdAca`,
	"collapseLine": `TreeItem_collapseLine__s5BLp`,
	"order": `TreeItem_order__BiHQU`,
	"nextElement": `TreeItem_nextElement__P0j8v`,
	"childOrder": `TreeItem_childOrder__tAXnN`,
	"active": `TreeItem_active__3oLsz`,
	"linkActive": `TreeItem_linkActive__OQzR4`
};
export default ___CSS_LOADER_EXPORT___;
